import Tooltip from '@mui/material/Tooltip';
import { withStyles } from '@mui/styles';
import { Colors } from '../../../theme';
export const StyledTooltip = withStyles({
    tooltip: {
        color: Colors.black80,
        backgroundColor: Colors.white,
        borderRadius: '4px',
        boxShadow: '0 1px 8px 0 rgba(0, 0, 0, .10), 0px 2px 2px 0px rgba(0, 0, 0, 0.06), 0px 0px 1px 0px rgba(0, 0, 0, 0.15)',
        padding: '8px',
        fontSize: 14,
    },
})(Tooltip);
//# sourceMappingURL=styles.js.map